<template>
  <div id="payment-voucher-create" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock headerText="Create Payment Voucher">
            </HeaderDividerBlock>
            <v-row>
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">PO Number</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.po_id"
                  required
                  clearable
                  placeholder="Select PO Number"
                  :items="purchaseOrders"
                  item-text="po_number"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Branch Code</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.branch_id"
                  required
                  clearable
                  placeholder="Select Branch"
                  :items="branches"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Payment Amount</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.amount"
                  required
                  clearable
                  placeholder="Enter Amount"
                  type="number"
                  :rules="[amountRule]"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Payment Type</p>
                </v-col>
                <v-select
                  outlined
                  dense
                  v-model="form.payment_type"
                  :items="paymentTypes"
                  required
                  clearable
                  placeholder="Select Payment Type"
                ></v-select>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Status</p>
                </v-col>
                <v-select
                  outlined
                  dense
                  v-model="form.status"
                  :items="statusOptions"
                  required
                  clearable
                  placeholder="Select Status"
                ></v-select>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Financial year</p>
                </v-col>

                <v-autocomplete
                  outlined
                  dense
                  v-model="form.financial_year_id"
                  required
                  clearable
                  placeholder="Select financial year"
                  :items="financialyears"
                  item-text="year"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Attach Invoice</p>
                </v-col>
                <v-file-input
                  outlined
                  dense
                  v-model="form.path"
                  accept=".pdf, .jpg, .png, .jpeg, .docx"
                  placeholder="Upload Invoice"
                  clearable
                ></v-file-input>
              </v-col>

              <v-col cols="12" sm="12">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Remarks</p>
                </v-col>
                <v-text-field
                  placeholder="Enter Remarks"
                  outlined
                  dense
                  v-model="form.remarks"
                  required
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Submit Button -->
            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    v-if="hasPermission('payment_voucher.create')"
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                  >
                    Create Voucher
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { PaymentVoucherService } from "@/services/paymentVoucher-service.js";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "CreatePaymentVoucher",
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock,
  },
  data: () => ({
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    form: {
      po_id: "",
      branch_id: "",
      financial_year_id: "",
      amount: 0.0,
      payment_type: "",
      status: "",
      remarks: "",
      path: "",
    },
    purchaseOrders: [],
    branches: [],
    financialyears: [],
    paymentTypes: ["Cash", "Bank Transfer", "Card", "Cheque"],
    statusOptions: ["Save", "Save & Post"],
    loadingPurchaseOrders: false,
    loadingBranches: false,
    loadingYears: false,
    poMaxAmount: 0,
    poGrandTotal: 0,
  }),
  watch: {
    "form.po_id": {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          const selectedPO = this.purchaseOrders.find((po) => po.id === newVal);
          this.poGrandTotal = selectedPO ? selectedPO.grand_total : 0;
          this.fetchPOAmount(newVal);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
    amountRule() {
      return (v) =>
        v <= this.poGrandTotal - this.poMaxAmount
          ? true
          : `Amount cannot exceed PO amount (${this.poGrandTotal -
              this.poMaxAmount})`;
    },
  },
  created() {
    this.fetchPurchaseOrders();
    this.fetchBranches();
    this.fetchFinanacialYears();
  },
  methods: {
    async submit() {
      const amountValidation = this.amountRule(this.form.amount);
      if (amountValidation !== true) {
        this.errors = [amountValidation];
        this.snackbar = false;
        return;
      }

      this.loading = true;
      this.errors = null;

      try {
        const formData = new FormData();
        Object.keys(this.form).forEach((key) => {
          formData.append(key, this.form[key]);
        });

        const response = await PaymentVoucherService.createPaymentVoucher(
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log(response);
        this.succesMsg = "Payment Voucher created successfully!";
        this.snackbar = true;
        this.form = {
          po_id: "",
          branch_id: "",
          financial_year_id: "",
          amount: 0.0,
          payment_type: "",
          remarks: "",
          path: "",
          status: "",
        };
      } catch (error) {
        console.error(error);
        const data = error.response.data;
        this.errors = checkError.errorFormatting(data);
      } finally {
        this.loading = false;
      }
    },

    async fetchPurchaseOrders() {
      try {
        this.loadingPurchaseOrders = true;
        const purchaseOrders = await PaymentVoucherService.getAllPurchaseOrders();
        this.purchaseOrders = purchaseOrders.data;
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loadingPurchaseOrders = false;
      }
    },

    async fetchFinanacialYears() {
      try {
        this.loadingPurchaseOrders = true;
        const years = await PaymentVoucherService.getYears();
        this.financialyears = years.data;
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loadingYears = false;
      }
    },

    async fetchBranches() {
      try {
        this.loadingBranches = true;
        const branches = await PaymentVoucherService.getBranches();
        this.branches = branches.data;
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loadingBranches = false;
      }
    },
    async fetchPOAmount(poId) {
      try {
        const response = await PaymentVoucherService.getPOAmount(poId);
        this.poMaxAmount = response.total_amount || 0.0;
        this.form.amount = this.poGrandTotal - this.poMaxAmount;
      } catch (error) {
        this.form.amount = 0.0;
        console.error("Failed to fetch PO amount", error);
      }
    },

    clossSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
